export default __webpack_public_path__ + "static/media/pending-claim.6e43dc5c.svg";